import { cssVariable } from './cssVariables';

export type ShadowLayer = {
  offsetX: string;
  offsetY: string;
  blur: string;
  color: string;
};

export type Shadow = 'shadowXS' | 'shadowS' | 'shadowM' | 'shadowL';

export type ButtonShadow =
  | 'buttonShadowTertiaryDefault'
  | 'buttonShadowTertiaryHover'
  | 'buttonShadowTertiaryActive'
  | 'buttonShadowTertiaryDisabled'
  | 'buttonShadowSecondaryDefault'
  | 'buttonShadowSecondaryHover'
  | 'buttonShadowSecondaryActive'
  | 'buttonShadowPrimaryDefault'
  | 'buttonShadowPrimaryHover'
  | 'buttonShadowPrimaryActive'
  | 'buttonShadowDangerDefault'
  | 'buttonShadowDangerHover'
  | 'buttonShadowDangerActive'
  | 'buttonShadowSecondaryDangerDefault'
  | 'buttonShadowSecondaryDangerHover'
  | 'buttonShadowSecondaryDangerActive'
  | 'buttonShadowSecondaryDangerDisabled';

export const firstShadowSLayer: ShadowLayer = {
  offsetX: '0px',
  offsetY: '1px',
  blur: '3px',
  color: 'rgba(17, 23, 34, 0.12)',
};

export const secondShadowSLayer: ShadowLayer = {
  offsetX: '0px',
  offsetY: '1px',
  blur: '2px',
  color: 'rgba(17, 23, 34, 0.06)',
};

export const shadowXS = 'var(--shadow-xs)';

export const shadowS = 'var(--shadow-s)';

export const shadowM = 'var(--shadow-m)';

export const shadowL = 'var(--shadow-l)';

export const shadows: Record<Shadow, string> = {
  shadowXS,
  shadowS,
  shadowM,
  shadowL,
};

export const buttonShadow: Record<ButtonShadow, string> = {
  buttonShadowTertiaryDefault: cssVariable('buttonShadowTertiaryDefault'),
  buttonShadowTertiaryHover: cssVariable('buttonShadowTertiaryHover'),
  buttonShadowTertiaryActive: cssVariable('buttonShadowTertiaryActive'),
  buttonShadowTertiaryDisabled: cssVariable('buttonShadowTertiaryDisabled'),
  buttonShadowSecondaryDefault: cssVariable('buttonShadowSecondaryDefault'),
  buttonShadowSecondaryHover: cssVariable('buttonShadowSecondaryHover'),
  buttonShadowSecondaryActive: cssVariable('buttonShadowSecondaryActive'),
  buttonShadowPrimaryDefault: cssVariable('buttonShadowPrimaryDefault'),
  buttonShadowPrimaryHover: cssVariable('buttonShadowPrimaryHover'),
  buttonShadowPrimaryActive: cssVariable('buttonShadowPrimaryActive'),
  buttonShadowDangerDefault: cssVariable('buttonShadowDangerDefault'),
  buttonShadowDangerHover: cssVariable('buttonShadowDangerHover'),
  buttonShadowDangerActive: cssVariable('buttonShadowDangerActive'),
  buttonShadowSecondaryDangerDefault: cssVariable(
    'buttonShadowSecondaryDangerDefault'
  ),
  buttonShadowSecondaryDangerHover: cssVariable(
    'buttonShadowSecondaryDangerHover'
  ),
  buttonShadowSecondaryDangerActive: cssVariable(
    'buttonShadowSecondaryDangerActive'
  ),
  buttonShadowSecondaryDangerDisabled: cssVariable(
    'buttonShadowSecondaryDangerDisabled'
  ),
};
